import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from "vue";
import Multiselect from "vue-multiselect";
import { useMultiselect } from "@/composables/useMultiselect";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTags, faCheck, faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";
import Tag from "./Tag.vue";
import { useUserTags } from "@/composables/user";
import { useToast } from "@/composables/toast";
import { useUid } from "@/composables/utils/uid";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StatelessTags',
    props: {
        value: { default: () => [] },
        disabled: { type: Boolean, default: false },
        clickable: { type: Boolean, default: false },
        useToggleLink: { type: Boolean, default: true },
        maxVisibleTags: { default: 5 },
        placeholder: { default: "Add Tags" },
        noPadding: { type: Boolean }
    },
    emits: ["input", "tag-click"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faTags, faCheck, faTimes, faPlus);
        const { userTags, addLocalTag } = useUserTags();
        const { warning } = useToast();
        function onAddTag(tag) {
            const newTag = tag.trim();
            if (isValid(newTag)) {
                addLocalTag(newTag);
                emit("input", [...props.value, newTag]);
            }
            else {
                warning(`"${newTag}" is not a valid tag.`, "Invalid Tag");
            }
        }
        function onInput(val) {
            emit("input", val);
        }
        function onDelete(tag) {
            const val = [...tags.value];
            const index = tags.value.indexOf(tag);
            val.splice(index, 1);
            emit("input", val);
        }
        const { editing, ariaExpanded, onOpen, onClose } = useMultiselect();
        const multiselectElement = ref(null);
        function openMultiselect() {
            var _a;
            //@ts-ignore bad library types
            (_a = multiselectElement.value) === null || _a === void 0 ? void 0 : _a.activate();
        }
        const tags = computed(() => props.value.map((tag) => tag.replace(/^name:/, "#")));
        const toggledOpen = ref(false);
        const toggleButtonId = useUid("toggle-link-");
        const trimmedTags = computed(() => {
            if (!props.useToggleLink || toggledOpen.value) {
                return tags.value;
            }
            else {
                return tags.value.slice(0, props.maxVisibleTags);
            }
        });
        const slicedTags = computed(() => {
            if (!props.useToggleLink) {
                return [];
            }
            else {
                return tags.value.slice(props.maxVisibleTags);
            }
        });
        const invalidTagRegex = /([.:\s][.:\s])|(^[.:])|([.:]$)|(^[\s]*$)/;
        function isValid(tag) {
            if (typeof tag === "string") {
                return !tag.match(invalidTagRegex);
            }
            else {
                return !tag.label.match(invalidTagRegex);
            }
        }
        function onTagClicked(tag) {
            emit("tag-click", tag);
        }
        return { __sfc: true, props, emit, userTags, addLocalTag, warning, onAddTag, onInput, onDelete, editing, ariaExpanded, onOpen, onClose, multiselectElement, openMultiselect, tags, toggledOpen, toggleButtonId, trimmedTags, slicedTags, invalidTagRegex, isValid, onTagClicked, Multiselect, FontAwesomeIcon, Tag };
    }
});
